var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v("Lista de Feather Icons")]),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.search,
          expression: "search",
        },
      ],
      staticClass: "search-input",
      attrs: { type: "text", placeholder: "Digite o nome do ícone" },
      domProps: { value: _vm.search },
      on: {
        input: function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.search = $event.target.value
        },
      },
    }),
    _c(
      "div",
      { staticClass: "icons-container" },
      _vm._l(_vm.filteredIcons, function (IconComponent, name) {
        return _c(
          "div",
          { key: name, staticClass: "icon-item" },
          [
            _c(IconComponent, { tag: "component", attrs: { size: "32" } }),
            _c("p", { staticClass: "icon-name" }, [_vm._v(_vm._s(name))]),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }